import { SvgIcon } from "@mui/material";
import { bbox, Feature, toMercator } from "@turf/turf";
import { dryMatterToColor } from "common/utils/grazing-logic";
import geojson2svg from "geojson2svg";

interface FieldIconProps {
  geom?: Feature;
  dryMatterNow: number;
}

export default function FieldIcon({ geom, dryMatterNow }: FieldIconProps) {
  const bboxEPSG3857 = bbox(toMercator(geom as Feature));
  const converter = geojson2svg({
    viewportSize: { width: 24, height: 24 },
    mapExtent: {
      left: bboxEPSG3857[0],
      bottom: bboxEPSG3857[1],
      right: bboxEPSG3857[2],
      top: bboxEPSG3857[3],
    },
    output: "path",
  });

  const fieldColor = dryMatterToColor(dryMatterNow, "#b9b9b9");
  const pathData = converter.convert(toMercator(geom as Feature));

  return (
    <SvgIcon
      htmlColor={fieldColor}
      sx={{
        color: fieldColor,
        // Ensure the color is applied to the SVG element
        "& svg": {
          color: fieldColor,
        },
        // Force the fill on the path element with high specificity
        "& path": {
          fill: `${fieldColor} !important`,
          stroke: "none !important",
        },
      }}
    >
      <path
        d={pathData}
        fill={fieldColor}
        stroke="none"
        style={{ fill: fieldColor, stroke: "none" }}
      />
    </SvgIcon>
  );
}
